var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BTable',_vm._g(_vm._b({attrs:{"selected":_vm.value,"headers":_vm.headers,"actions":_vm.actions,"list":_vm.list},scopedSlots:_vm._u([{key:"item.file_types",fn:function(ref){
var v = ref.value;
return [_vm._l((v),function(item){return [_c('v-chip',{key:item,staticClass:"pa-2 mr-1",attrs:{"small":""}},[_vm._v(" "+_vm._s(item)+" ")])]})]}}])},'BTable',_vm.$attrs,false),_vm.$listeners || {}))}
var staticRenderFns = []

export { render, staticRenderFns }